import { __assign } from "tslib";
import * as React from 'react';
import { Button } from '../Button';
export var DefaultButton = React.forwardRef(function (props, ref) { return (React.createElement(Button, __assign({ variant: "contained", color: "secondary" }, props, { ref: ref }))); });
export default DefaultButton;
//# sourceMappingURL=DefaultButton.js.map